import React, { useState } from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';

import './ConfirmationScreen.scss';

interface Props {
    title: string;
    link: React.ReactNode;
}

const ConfirmationScreen: React.FC<Props> = ({ title, link }) => {
    const translated = useTranslation();
    const [open, setOpen] = useState(false);
    return (
        <div className="sgw-content">
            <div className="confirmation-screen__rich-icon-container">
                <RichIcon type={RichIconTypes.KALKULATOR} className="confirmation-screen__rich-icon" />
            </div>
            <h2 className="typography-h2__light">{translated.confirmationScreen.title}</h2>
            <p>{format(translated.confirmationScreen.description, title)}</p>

            <LinkButton
                icon={open ? IconTypes.LITEN_PIL_OPP : IconTypes.LITEN_PIL_NED}
                iconOnRightSide
                onClick={() => setOpen(!open)}
            >
                {translated.confirmationScreen.toggleButtonText}
            </LinkButton>
            {open && (
                <>
                    <p id="confirmation-screen-list-title" className="confirmation-screen__list-title">
                        {translated.confirmationScreen.listTitle}
                    </p>
                    <ul aria-labelledby="confirmation-screen-list-title" className="confirmation-screen__list">
                        <li>{translated.confirmationScreen.phone}</li>
                        <li>{translated.confirmationScreen.email}</li>
                        <li>{translated.confirmationScreen.customerRelationship}</li>
                    </ul>
                </>
            )}
            <div className="confirmation-screen__link-container">{link}</div>
        </div>
    );
};

export default ConfirmationScreen;
